import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { API_ENDPOINT, API_TIMEOUT } from 'src/settings';
import { getSession } from './getSession';

export const MISSING_ID_TOKEN = 'ID Token missing from user session';

interface ApiCallOptions {
  data?: Record<string, unknown>;
  headers?: Record<string, string>;
  method?: 'GET' | 'POST';
  url: string;
}

export interface ApiCallResponse<T = unknown> {
  data: T;
}

export const apiCall = async <T = unknown>({
  data,
  headers,
  method = 'GET',
  url,
}: ApiCallOptions): Promise<ApiCallResponse<T>> => {
  const response = await fetchJSONWithTimeout(`${API_ENDPOINT}${url}`, {
    body: data,
    headers,
    method,
    timeout: API_TIMEOUT,
  });

  if (!response.ok) {
    throw new Error(`Request to ${url} failed with status ${response.status}`);
  }

  const text = await response.text();

  return { data: text ? JSON.parse(text) : undefined };
};

export const authenticatedApiCall = async <T = unknown>(
  options: ApiCallOptions,
): Promise<ApiCallResponse<T>> => {
  const session = await getSession();
  const idToken = session?.idToken.jwtToken;

  if (!idToken) {
    throw new Error(MISSING_ID_TOKEN);
  }

  return apiCall<T>({ ...options, headers: { ...options.headers, 'x-id-token': idToken } });
};
